<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div
    class="mb-4 d-flex"
  >
    <v-spacer />
    <v-card
      class="d-flex justify-center align-center"
      color="#eeeeee"
      flat
      :height="size"
      :width="size"
      @click="startUpload"
    >
      <img-with-loading
        v-if="fileStore"
        :height="size"
        :img-src="uploadUrl"
      />
      <template
        v-else-if="currentUrl"
      >
        <img-with-loading
          :height="size"
          :img-src="currentUrl"
        />
      </template>
    </v-card>
    <div style="width: 12px;position: absolute">
      <v-file-input
        ref="file"
        v-model="fileStore"
        :rules="rules"
        accpet="image/*"
        class="mt-2"
        counter
        dense
        outlined
        prepend-icon=""
        prepend-inner-icon="mdi-file"
        show-size
        style="height: 0;opacity: 0"
      />
    </div>
  </div>
</template>

<script>
import ImgWithLoading from '@/plugins/EntityFrameWork/Base/ImgWithLoading.vue'

export default {
  name: 'BaseFileUpload',
  components: { ImgWithLoading },
  props: {
    value: {},
    currentUrl: {},
    rules: {}
  },
  watch: {
    fileStore (val) {
      this.$emit('input', val)
    }
  },
  data: function () {
    return {
      fileStore: null,
      size: '48'
    }
  },
  computed: {
    uploadUrl: function () {
      return URL.createObjectURL(this.fileStore)
    }
  },
  methods: {
    startUpload () {
      this.$refs.file.$refs.input.click()
    }
  }
}
</script>

<style scoped>

</style>
